import { Link } from '@remix-run/react'
import { Icon } from '#app/shared/ui/icons/Icon.js'
import { Button } from '#app/shared/ui/inputs/button/Button.js'

type Props = {
  carSlug: string
}

export default function ConfirmReservation({ carSlug }: Props) {
  return (
    <div
      className={`
        flex flex-col items-center justify-center gap-4 rounded-l-base border
        border-l-0 border-neutral-75 bg-white px-4 py-6

        lg:min-h-[595px]

        xl:w-full
      `}
    >
      <img src="/img/Group 222.svg" alt="icon" className="h-[94px] w-[94px]" />
      <p
        className={`
          text-center text-h4 text-neutral-900

          lg:text-h3
        `}
      >
        Reserva tu coche
      </p>
      <p
        className={`
          text-center text-base-medium text-neutral-500

          xl:w-[378px]
        `}
      >
        Realiza tu reserva ahora, y uno de nuestros agentes te guiará en el
        siguiente proceso para que tengas todo listo.
      </p>
      <div
        className={`mt-5 flex w-full flex-col items-center justify-center gap-2`}
      >
        <Link to={`/coche/${carSlug}/reservar`}>
          <Button
            className={`h-12 w-[255px] whitespace-nowrap`}
            variant={'primary'}
          >
            Quiero Reservarlo
          </Button>
        </Link>
        <Link to={`/coche/${carSlug}/mas-informacion`}>
          <Button
            variant={'outlineInput'}
            className={`
              flex h-12 w-[255px] items-center justify-center gap-4
              border-neutral-900 pl-6 pr-4
            `}
          >
            <p
              className={`
                whitespace-nowrap text-nowrap text-base-bold text-neutral-900
              `}
            >
              Necesito más información
            </p>
            <Icon
              size="16px"
              className="text-neutral-900"
              name="basic/arrow-right"
            />
          </Button>
        </Link>
      </div>

      <p className="mt-7 text-center text-base-medium">
        <span className="text-neutral-600">
          ¿Tienes dudas sobre las opciones de pago?
        </span>{' '}
        <Link to={`/contacto`} className={`text-primary-600 underline`}>
          Consulta aquí
        </Link>
      </p>
    </div>
  )
}
